import { useEffect, useState, type ReactNode } from 'react'
import { Button, Card } from '@heroui/react'
import { appBuild, serverBuild } from '../lib/newBuild'
import { languageName } from '../lib/staffText'
import { Icon } from '../ui/icons'
import { LanguageMenu } from '../ui/LanguageMenu'
import { Logo } from '../ui/Logo'
import { useStaffText } from '../ui/StaffText'
import { readTheme, saveTheme, type Theme } from '../ui/theme'
import '../styles/entry.css'

/**
 * The frame of the two screens that come before the top bar: signing in, and the
 * new-password wall. One centred card on a soft glow, the theme toggle in the corner.
 */
export function EntryFrame({ children }: { children: ReactNode }) {
  const { lang, say } = useStaffText()
  const [theme, setTheme] = useState<Theme>(readTheme)
  const [build, setBuild] = useState(appBuild)
  useEffect(() => {
    if (build) return
    let live = true
    void serverBuild().then((b) => live && b && setBuild(b))
    return () => {
      live = false
    }
  }, [build])
  const flip = () => {
    const next = theme === 'light' ? 'dark' : 'light'
    saveTheme(next)
    setTheme(next)
  }
  return (
    <div className="entry">
      <div className="entry-corner">
        <LanguageMenu />
        <Button isIconOnly variant="ghost" size="sm" onPress={flip} aria-label={theme === 'light' ? say('ui.themeDark') : say('ui.themeLight')}>
          <Icon name={theme === 'light' ? 'moon' : 'sun'} size={18} />
        </Button>
      </div>
      <main className="entry-main">
        <Card className="entry-box">
          <div className="entry-logo">
            <Logo product={false} />
          </div>
          {children}
        </Card>
        <footer className="entry-foot">
          <span>{say('entry.copyright', { year: String(new Date().getFullYear()) })}</span>
          <span>{languageName(lang)}</span>
          {build && <span title={say('entry.build')}>{build}</span>}
        </footer>
      </main>
    </div>
  )
}
